import CurrencySelect from '@components/CurrencySelect'
import React from 'react'
import { FormInputComponent } from '../../Itinerary/AddEventModal/FormComponents'

interface TripFormProps {
	formId: string
	name: string
	currencyCode: string
	onNameChange: (name: string) => void
	onCurrencyChange: (currencyCode: string) => void
	onSubmit: (e: React.FormEvent) => void
}

const TripForm: React.FC<TripFormProps> = ({
	formId,
	name,
	currencyCode,
	onNameChange,
	onCurrencyChange,
	onSubmit,
}) => {
	return (
		<form id={formId} onSubmit={onSubmit}>
			<FormInputComponent
				label="Trip Name"
				htmlFor="trip-name"
				id="trip-name"
				type="text"
				value={name}
				onChange={e => onNameChange(e.target.value)}
				placeholder="Enter trip name..."
				required
				autoFocus
				maxLength={64}
			/>
			<CurrencySelect
				label="Default Currency"
				htmlFor="trip-currency"
				value={currencyCode}
				onChange={onCurrencyChange}
			/>
		</form>
	)
}

export default TripForm
